export class UserModule {
    id!: number;
    userId!: number;
    moduleId!: number;
    moduleName?: string;
    clientId?:string;
    sortOrder?: number;
}
